<template>
    <div class="breadcrumbBox">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item @click="jump('VOCSystemHome')">首页</el-breadcrumb-item>
            <template v-if="routerName==='光化学污染'">
                <el-breadcrumb-item>{{routerName}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{name}}</el-breadcrumb-item>
            </template>
            <template v-else>
                <el-breadcrumb-item>{{routerName}}</el-breadcrumb-item>
            </template>

        </el-breadcrumb>
    </div>
</template>

<script>
    export default {
        name: "breadcrumb",
        data() {
            return {
                routerName: '',
            }
        },
        computed: {
            name: {
                get() {
                    return this.$route.query.name
                }
            }
        },
        mounted() {
            this.routerName = this.$router.history.current.meta.name

            // console.log(this.$router)
        },
        methods: {
            jump(routerName) {
                this.$router.push({name: routerName})
            }
        }
    }
</script>

<style scoped lang="less">
    .breadcrumbBox {
        padding: 8px;
    }
</style>